<template>
  <div
    v-if="statusVisible"
    class="alert"
    role="alert"
    :class="{ 'alert-danger': statusIsError, 'alert-success': statusIsSuccess }"
    v-html="statusMessage"
  ></div>
</template>

<script>
  export default {
    name: "StatusMessage",
    data: function () {
      return {
        statusIsError: false,
        statusIsSuccess: false,
        statusTimeout: 6000,
        statusThread: null,
        statusVisible: false,
        statusMessage: "",
        statusInstances: [],
      };
    },
    methods: {
      displaySuccessMessage(message, data) {
        this.displayStatusMessage(message, "success", this.statusTimeout * 3, data);
      },
      displayErrorMessage(message, data) {
        this.displayStatusMessage(message, "error", this.statusTimeout, data);
      },
      displayStatusMessage(message, type, timeout, data) {
        this.clearThreads();

        if (type == "error") {
          this.statusIsError = true;
          this.statusIsSuccess = false;
        } else if (type == "success") {
          this.statusIsError = false;
          this.statusIsSuccess = true;
        }

        if (
          this.$root.messageCollection &&
          typeof this.$root.messageCollection[message] !== "undefined"
        ) {
          // Get the i18n key from messageCollection and translate it
          const i18nKey = this.$root.messageCollection[message];
          this.statusMessage = this.$t(i18nKey);
        } else {
          // Try to translate the message directly, fallback to raw message if not found
          const translated = this.$t(message);
          this.statusMessage = translated !== message ? translated : message;
        }

        if (typeof data === "object") {
          for (var i in data) {
            this.statusMessage = this.statusMessage.replace(":" + i, data[i]);
          }
        }

        this.statusVisible = true;

        this.statusThread = setTimeout(() => {
          this.resetStatusMessage();
        }, timeout);

        this.statusInstances.push(this.statusThread);
      },
      compileMessage(messageSource, data) {},
      clearThreads() {
        for (var i in this.statusInstances) {
          clearTimeout(this.statusInstances[i]);
        }
      },
      resetStatusMessage() {
        this.statusVisible = false;
        this.statusMessage = "";
        this.statusThread = null;
        this.statusIsError = false;
        this.statusIsSuccess = false;
      },
    },
  };
</script>
